var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 0.825684,
    y: 0.412842,
    width: 35.1743,
    height: 35.1743,
    rx: 17.5872,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M26.091 10.7908L18.4131 18.0003L26.091 25.2099",
    stroke: "#001A27",
    strokeWidth: 3.74387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M10.7352 25.2092L18.4131 17.9997L10.7352 10.7901",
    stroke: "#001A27",
    strokeWidth: 3.74387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.ed837ba7d51dad9e2b7c67c58dcc9c1d.svg";
export { ForwardRef as ReactComponent };